<div>
    <div [ngClass]="{'row-youth-worker': participantId != studentId, 'row-student': participantId == studentId}">
        <div [ngClass]="{'col-youth-worker' : participantId != studentId, 'col-student': participantId == studentId}">
            <img *ngIf="(participantId == studentId) && studentAvatar == null" src="../../../../assets/account-circle.svg" class="avatar"/>
            <img *ngIf="!avatarId && participantId != studentId" src="../../../../assets/account-circle.svg" class="avatar"/>
            <img *ngIf="(participantId == studentId) && studentAvatar != null" [src]="studentAvatar | safeHtml" class="avatar"/>
            <img *ngIf="participantId != studentId" [src]="'data:image/jpg;base64,'+ avatarId | safeHtml" class="avatar"/>
        </div>
        <div [ngClass]="{'col-youth-worker' : participantId != studentId, 'col-student': participantId == studentId}">
            <p class="message" [ngClass]="{'message-component-student': participantId == studentId}" *ngIf="!messageData.hasAsset">{{ messageData.textContent }}</p>

            <p class="message" style="margin-top: 2px;" 
                [ngClass]="{'message-component-student': (participantId == studentId), 'message-content-image': isImageContent(messageData.messageAssetInfo.binaryContentType)}" 
                *ngIf="messageData.hasAsset"
            > 
                <!-- PDF files -->
                <span *ngIf="isPdfContent(messageData.messageAssetInfo.binaryContentType)" class="message-content">
                    <a 
                        
                        class="message-download pdf-link" 
                        (click)="onPdfDownloadClick(assetData)"
                    >
                        <span>{{ messageData.messageAssetInfo.fileName }}</span>
                    </a>
                    <mat-icon class="download-icon">download</mat-icon>
                </span>
                
                <!-- Image Messages -->
                <a 
                    *ngIf="isImageContent(messageData.messageAssetInfo.binaryContentType)" 
                    class="message-download" 
                    [href]="assetData | safeHtml"
                    target="_blank"
                >
                    <img 
                        [src]="assetData | safeHtml"
                        class="message-image"
                    />
                    <span *ngIf="!isImageContent(messageData.messageAssetInfo.binaryContentType)">{{ messageData.messageAssetInfo.fileName }}</span>
                </a>

                <!-- This will be for everything not a PDF/Image  -->
                <span *ngIf="isDownloadableContent(messageData.messageAssetInfo.binaryContentType)" class="message-content">
                    <a 
                        class="message-download" 
                        [href]="assetData | safeHtml"
                        target="_blank"
                        [download]="messageData.messageAssetInfo.fileName"
                    >
                        <span>{{ messageData.messageAssetInfo.fileName }}. {{ messageData.messageAssetInfo.fileType}}</span>
                    </a>
                    <mat-icon class="download-icon">download</mat-icon>
                </span>
                
            </p>
            <p [ngClass]="participantId != studentId ? 'date' : 'date-student'">{{ messageDate | date:'MMM dd - hh:mm a'  }}</p>
        </div>
    </div>
</div>